import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PanelModule} from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { VisualisationComponent } from './visualisation.component';
import { TableModule } from 'primeng';




@NgModule({
  declarations: [VisualisationComponent],
  imports: [
    CommonModule,
    PanelModule,
    ButtonModule,
    TableModule
  ]
})
export class VisualisationModule { }
